import { Event } from "@mui/icons-material";
import moment from "moment";
import React from "react";
import { Iso8601Date } from "../../common/service/server/Types";
import clsx from "clsx";
import { daysRemaining, fmtDateForRow } from "./dataRequest/DataRequestSubjectCard";
import { Chip } from "@mui/material";

type DueDateProps = {
  date: Iso8601Date;
  icon?: boolean;
  condensed?: boolean;
  noDueLabel?: boolean; // If shown in e.g., a table where a header of "Due" is present already, omit the "Due" label
  asChip?: boolean; // If shown in e.g., a table where we don't want to let the card expand vertically, use the Chip element to contain it
};
export const DueDate: React.FC<DueDateProps> = ({
  date,
  icon = false,
  condensed = false,
  noDueLabel = false,
  asChip = false,
}) => {
  const deadline = moment(date);

  const originalRemaining = daysRemaining(deadline);
  const remaining = Math.abs(originalRemaining);

  let altDateString: string | undefined = undefined;
  let dateString = fmtDateForRow(date);
  let warning = false;
  let danger = false;
  if (originalRemaining < 0) {
    altDateString = dateString;
    dateString = `${noDueLabel ? "" : "Due "}${remaining} ${remaining === 1 ? "day" : "days"} ago`;
    danger = true;
  } else if (originalRemaining <= 5) {
    altDateString = dateString;
    dateString = `${noDueLabel ? "" : "Due "}${
      remaining === 0 ? "today" : remaining === 1 ? "tomorrow" : `in ${remaining} days`
    }`;
    warning = true;
  } else {
    dateString = `${noDueLabel ? "" : "Due "}${dateString}`;
  }

  // If not showing "Due", still capitalize 1st letter of whatever we do start with.
  if (noDueLabel && dateString) {
    dateString = dateString.charAt(0).toUpperCase() + dateString.slice(1);
  }

  if (asChip) {
    return <Chip label={dateString} color={danger ? "error" : warning ? "warning" : "default"} />;
  }

  return (
    <div
      className={clsx("request-due-date due-date-card", {
        "request-due-date--warning": warning,
        "due-date-card--warning": warning,
        "due-date-card--danger": danger,
        "due-date-card--condensed": condensed,
      })}
      title={altDateString}
    >
      {icon && <Event className="mr-xs" />}
      {dateString}
    </div>
  );
};
